import { INewsForBanner } from './types';
import { AnyAction } from 'redux';
import { ThunkAction } from '../../reduxStore/types';
import { fetchNewsForBanner } from './http';

export enum EnumNewsActionTypes {
  SET_NEWS_FOR_BANNER = 'SET_NEWS_FOR_BANNER',
  SET_NEWS_BANNER_SHOWN = 'SET_NEWS_BANNER_SHOWN',
}

export const setNewsForBannerAction = (payload: INewsForBanner[]): AnyAction => ({
  type: EnumNewsActionTypes.SET_NEWS_FOR_BANNER,
  payload,
});

export const setNewsBannerShown = (payload: boolean): AnyAction => ({
  type: EnumNewsActionTypes.SET_NEWS_BANNER_SHOWN,
  payload,
});

export default {
  setNewsForBanner: (): ThunkAction => async (dispatch, _, fetcher) => {
    try {
      const data = await fetchNewsForBanner(fetcher);
      await dispatch(setNewsForBannerAction(data));
    } catch (e) {
      await dispatch(setNewsForBannerAction([]));
    }
  },
};
